export default __webpack_public_path__ + "static/media/authors.84453f2b.svg";